import moment from 'moment-timezone';

import {
  getIntervalCode,
  INTERVAL_TYPE,
} from '../actions/common/TimeInterval';

export const getDefaultInterval = () => ({
  dateRange: {
    timeEnd: moment().tz(moment.tz.guess(true)),
    timeStart: moment().tz(moment.tz.guess(true)).subtract(24, 'hours'),
  },
  intervalType: INTERVAL_TYPE.CUSTOM,
  relativeEnd: '',
  relativeStart: '',
});

export const getSelectedInterval =
(defaultInterval = getDefaultInterval()) =>
  (slice, insertId) => {
    const { selectedInterval = {} } = slice;

    const {
      [insertId]: orgSelectedInterval = defaultInterval,
    } = selectedInterval;

    return orgSelectedInterval;
  };

// selectedInterval's code for using as Redux key
export const getSelectedIntervalCode = (selectedInterval) => {
  const intervalCode = getIntervalCode(selectedInterval);

  return intervalCode;
};
